var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

   template: require('./template.hbs'),

    initialize: function( options ) {

        this.channel = options.channel;

    },

    ui: {
        showByPageOrSearchRadioBtns:    '[name=page_or_search]'
    },

    events: {
        'change @ui.showByPageOrSearchRadioBtns': 'pageOrSearchViewByRadioChange',

    },

    serializeData: function() {

        var state = this.channel.request('state'),
            showResultsByPage = state.get('showResultsByPage'),
            disableShowResultsBySearch = false, //state.getNumberOfSearches() < 2,
            showResultsBySearch = disableShowResultsBySearch ? false : !showResultsByPage;


        return {
            showResultsByPage: showResultsByPage,
            showResultsBySearch: showResultsBySearch,
            disableShowResultsBySearch: disableShowResultsBySearch

        };

    },

    pageOrSearchViewByRadioChange: function(e) {

        var $target = $(e.target),
            showByPage = $target.val() === 'PAGE'; // (hard coded now ... could get from reason code collection )

        this.channel.trigger( 'findAndRedact:updateShowResultsByTable', showByPage );

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/resultsHeader/view.js
 ** module id = 644
 ** module chunks = 0
 **/